var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
import { html } from 'lit';
import { SdsTagBase } from '../_sds-tag-base.lit';
import styles from './sds-tag.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
import { ifDefined } from 'lit-html/directives/if-defined.js';
/**
 * A standard tag component that displays text content with optional styling.
 *
 * This component extends the base tag functionality to provide a simple tag
 * that can be used to label, categorize, or highlight information.
 *
 * @tag sds-tag
 *
 * @fires click - Fired when the tag is clicked
 */
let SdsTag = (() => {
    let _classDecorators = [sdsCustomElement('sds-tag')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsTagBase;
    var SdsTag = _classThis = class extends _classSuper {
        /**
         * Renders the tag component.
         *
         * @returns A template result containing the rendered tag
         */
        render() {
            return html ` ${this.renderTag()} `;
        }
        /**
         * Renders the tag element with its content and styling.
         *
         * @returns A template result containing the tag element
         * @private
         */
        renderTag() {
            const ariaAttributes = this.getAriaAttributes();
            return html `
            <div
                class="${this.getClasses()}"
                @click="${() => this.handleClick()}"
                @mousedown="${() => this.handleMouseDown()}"
                @focus="${() => this.handleFocus()}"
                @blur="${() => this.handleBlur()}"
                @keydown="${(e) => this.handleKeyDown(e)}"
                .disabled="${this.disabled}"
                tabindex="${this.clickable || this.selectable ? '0' : '-1'}"
                role="${ariaAttributes.role}"
                aria-disabled="${ariaAttributes['aria-disabled']}"
                aria-label="${ariaAttributes['aria-label']}"
            >
                <sds-clipped-text
                    basic
                    text="${this.name}"
                    lines="${ifDefined(this.lines ? this.lines : undefined)}"
                ></sds-clipped-text>
            </div>
        `;
        }
    };
    __setFunctionName(_classThis, "SdsTag");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTag = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTag = _classThis;
})();
export { SdsTag };
